<script setup>
import { ref } from 'vue'
import JobListItem from './JobListItem.vue'

const items = ref([

])
</script>

<template>
    <ul class="job-finder__list">
        <JobListItem />
        <JobListItem />
        <JobListItem />
        <JobListItem />
        <JobListItem />
        <JobListItem />
    </ul>
    <div class="archive-navigation">
        <div class="left">
            <label for="per_page">
                Počet ponúk na stranu
            </label>
            <select name="per_page" id="per_page">
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select>
        </div>
        <div class="right">
            <nav class="c-pagination">
                <ul>
                    <li>
                        <a href="#">
                            1
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            2
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            3
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            4
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            5
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>